import { EventCardFragment } from '@/__generated__/graphql';
import { useMemo } from 'react';
import { parseEventTimeFragment } from '../parsers/common';

// Custom hook to sort event items by date
export const toEventTimeOrder = (items: EventCardFragment[]) => {
  return useMemo(() => {
    return items
      ? [...items].sort((a, b) => {
          const dateA = parseEventTimeFragment(a.eventTime)[0]?.date || '';
          const dateB = parseEventTimeFragment(b.eventTime)[0]?.date || '';
          return new Date(dateA).getTime() - new Date(dateB).getTime();
        })
      : [];
  }, [items]);
};
